// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import AMap from 'vue-amap';
import '@/CValidation/YValidation'

import tools from './tools/tools'
import mixin from './mixin/index'
import 'vue-orgchart/dist/style.min.css'
//UI组件
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

Vue.use(tools);
Vue.mixin(mixin);
// Vue.use(VeeValidate);
// 初始化vue-amap
Vue.use(AMap);

AMap.initAMapApiLoader({
// 申请的高德key
    key: '72af12ad83a3101eeb9d688426251388',
// 插件集合
    plugin: ['AMap.Autocomplete','AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.CitySearch']
});
Vue.config.productionTip = false;
Vue.prototype.$layer = window.layer;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js